export default {
    getActiveIndicatorId(state) {
        return state.activeIndicatorId;
    },
    getActiveIndicatorData(state) {
        return state.activeIndicatorData;
    },
}
